import { Card } from '@mui/material';
import RichContent from '@/components/shared/rich-content';
import { useViewStore } from '@/stores';
import type { Question } from '@/types';

export default function ExplanationGeneral({ question }: { question: Question }) {
  const { showExplanations } = useViewStore();
  const { id, explanationNode } = question;
  const explanationIsActive = showExplanations.indexOf(id) > -1;
  if (!explanationNode || !explanationIsActive) return null;

  return (
    <Card
      variant="outlined"
      sx={{
        p: '10px 15px 1px',
        mb: 2,
        overflowY: 'auto',
        userSelect: 'none',
      }}>
      <RichContent content={explanationNode} />
    </Card>
  );
}
